import { createSlice } from '@reduxjs/toolkit';
import { UserInfoState } from './types';
import { RootState } from '@app/store';

const initialState: UserInfoState = {
  data: null,
  isLoading: false,
  error: null,
};

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.data = action.payload;
      state.error = null;
    },
    clearUserInfo: (state) => {
      state.data = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

// Селекторы
export const selectUserInfo = (state: RootState) => state.userInfo.data;
export const selectUserId = (state: RootState) => state.userInfo.data?.discordId;
export const selectUserBalancePyl = (state: RootState) => state.userInfo.data?.balancePyl;
export const selectUserBalanceGCoin = (state: RootState) => state.userInfo.data?.balanceGCoin;
export const selectUserName = (state: RootState) => state.userInfo.data?.discordUsername;
export const selectIsPremium = (state: RootState) => state.userInfo.data?.isPremium;
export const selectUserActivityRank = (state: RootState) => state.userInfo.data?.activityRank;
export const selectUserMatchAmount = (state: RootState) => state.userInfo.data?.match_amount || "2";
export const selectTradeLink = (state: RootState) => state.userInfo.data?.tradelink;
export const selectUserRole = (state: RootState) => state.userInfo.data?.role;

export const { setUserInfo, clearUserInfo, setError } = userInfoSlice.actions;